// Przestrzeń nazw 'businessHours': kalendarz godzin pracy, edytor tygodniowy, modal dnia.
//
// VERIFY: cały plik poza `title`, brak w mockupie. Mockup ma tylko przełącznik „Odbieranie po
// godzinach pracy" i wykres „w godzinach pracy / poza godzinami pracy"; nasz ekran to kalendarz
// z godzinami stałymi i tymczasowymi oraz edytor tygodnia. Terminy trzymają słownik projektu
// („godziny pracy", „zamknięte").
export default {
  title: 'Godziny pracy',
  // Klucze zgodne z `weekday` w API (`monday`…`sunday`). Etykieta idzie ze słownika, a do
  // dopasowania danych zostaje angielski klucz.
  weekdays: {
    monday: 'Poniedziałek',
    tuesday: 'Wtorek',
    wednesday: 'Środa',
    thursday: 'Czwartek',
    friday: 'Piątek',
    saturday: 'Sobota',
    sunday: 'Niedziela',
  },
  closed: 'Zamknięte',
  today: 'Dziś',
  todayMarker: '(Dziś)',
  legend: {
    permanent: 'Stałe',
    temporary: 'Tymczasowe',
  },
  manage: 'Zarządzaj godzinami pracy',
  // {{manage}} to etykieta przycisku powyżej, żeby wskazówka nie rozjechała się z przyciskiem.
  hint: 'Użyj przycisku „{{manage}}”, aby edytować regularny tygodniowy harmonogram tej firmy. Wybierz konkretny dzień, aby ustawić godziny tymczasowe.',
  timezone:
    'Wybrana firma znajduje się w strefie czasowej <tz>{{timezone}}</tz>. Godziny pracy są wyświetlane w czasie lokalnym firmy.',
  permanent: {
    title: 'Regularny harmonogram tygodniowy',
  },
  day: {
    allDay: 'Cały dzień',
  },
  modal: {
    // {{weekday}}, {{date}}: np. „Poniedziałek, 3 sie 2026".
    title: '{{weekday}}, {{date}}',
    subtitle: 'Ustaw godziny specjalne na ten dzień',
    from: 'Od:',
    to: 'Do:',
    closedAllDay: 'Zamknięte cały dzień',
    openAllDay: 'Otwarte cały dzień',
  },
  // Wspólne dla edytora tygodnia i modala dnia.
  validation: {
    endBeforeStart: 'Godzina zakończenia nie może być wcześniejsza niż godzina rozpoczęcia.',
    overlap:
      'Przedziały czasowe nie mogą się nakładać. Każdy przedział musi zaczynać się po zakończeniu poprzedniego.',
    sameTime:
      'Ustawienie takiej samej godziny rozpoczęcia i zakończenia oznaczy ten dzień jako zamknięty.',
  },
  notifications: {
    updated: 'Godziny pracy zostały zaktualizowane.',
    updateFailed: 'Nie udało się zaktualizować godzin pracy.',
  },
  // VERIFY: cała sekcja, brak w mockupie. Opisy strategii odpowiadają temu, co robi asystent
  // w llm (`_voicemail_prompt`), a nie samym nazwom wartości.
  afterHours: {
    title: 'Po godzinach pracy',
    hint: 'Co asystent proponuje dzwoniącemu, gdy urząd jest zamknięty.',
    loadError: 'Nie udało się załadować ustawień po godzinach pracy.',
    saved: 'Ustawienia po godzinach pracy zostały zapisane.',
    saveFailed: 'Nie udało się zapisać ustawień po godzinach pracy.',
    timeZone: {
      label: 'Strefa czasowa',
      help: 'Według niej liczone są godziny pracy. Zmiana przesuwa zapisane godziny.',
    },
    strategy: {
      label: 'Po godzinach asystent',
    },
    // Klucze = wartości `after_hours_strategy` w API.
    strategies: {
      none: {
        label: 'Nic nie proponuje',
        description: 'Informuje, że urząd jest zamknięty.',
      },
      voicemail: {
        label: 'Proponuje pocztę głosową',
        description: 'Przełącza na numer poczty głosowej podany niżej.',
      },
      voicemail_with_targets: {
        label: 'Proponuje pocztę głosową wydziału',
        description:
          'Przełącza na telefon po godzinach wybranego celu przekierowania, a gdy go nie ma, na numer poczty głosowej podany niżej.',
      },
      request_intake: {
        label: 'Przyjmuje zgłoszenie',
        description: 'Zapisuje sprawę i dane do kontaktu, żeby urząd oddzwonił.',
      },
    },
    voicemail: {
      label: 'Numer poczty głosowej',
      help: 'Z kierunkowym, np. +48 511 827 904. Wymagany przy obu opcjach poczty głosowej.',
    },
    validation: {
      timeZone: 'Wybierz strefę czasową z listy',
      phoneInvalid: 'Podaj numer z kierunkowym: +48 i 9 cyfr, np. +48 511 827 904',
      voicemailRequired: 'Podaj numer poczty głosowej dla tej opcji',
    },
  },
} as const;
